import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";

import { Button } from "@/components/atoms/prime/Button";

type NotificationDialogProps = {
  title: string;
  type?: "success" | "error" | "info";
  description?: string;
  details?: string[];
  onHide: () => void;
  visible?: boolean;
};

export function NotificationDialog({
  title,
  description,
  details,
  visible,
  type,
  onHide,
}: Readonly<NotificationDialogProps>) {
  const footer = () => {
    return <Button label="Cerrar" onClick={() => onHide()} />;
  };
  return (
    <Dialog
      footer={footer}
      header={title}
      pt={{
        content: ["bg-gray-100 pt-4"],
        footer: { className: "justify-center" },
      }}
      visible={visible}
      onHide={onHide}
    >
      <Message pt={{ root: ["ml-0 pl-0 font-bold"] }} severity={type} text={description} />
      {details && (
        <ul className="ml-2 mt-2 flex list-outside list-disc flex-col gap-2 px-4 text-sm text-gray-700">
          {details.map((detail, index) => (
            <li key={index}>{detail}</li>
          ))}
        </ul>
      )}
    </Dialog>
  );
}
